export default {
  'exception-403.exception.back': 'Voltar para Início',
  'exception-403.description.403': 'Desculpe, você não tem acesso a esta página',
};
